export const project = {
    featured:[
        {
            id: 1,
            name: "P&G Shiksha Showcase Web/Mobile App",
            link: "https://pgshiksha.com",
            team: "2",
            category: "Shocase",
            image: require("../assets/images/project/pgshiksha.jpeg"),
            description:
                "Worked with the team and Developed P&G Shiksha app with latest and trending transition and effects/animation.",
        },
        {
            id: 2,
            name: "Beshak",
            link: "https://www.beshak.org/",
            team: "8",
            category: "India's Insurance advisor platform",
            image: require("../assets/images/project/beshak.png"),
            description:
                "Beshak is India's first unbiased insurance advisor platform with marketplace to connect insurance buyers to insurance advisors.",
        },
        {
            id: 3,
            name: "Coverfox Insurance Broking Pvt. Ltd",
            link: "https://coverfox.com",
            team: "30",
            category: "Insurance Portal",
            image: require("../assets/images/project/cf.jpeg"),
            description:
                "Coverfox is the biggest InsurTech platform. Offers simple, quick and hassle-free online insurance broking services for car, bike, health, life and travel insurance. Web applications using HTML 5, PostCSS, STYLUS, CSS3, SASS, LESS, J-Query, J-Query Plugins, JavaScript, Git, Yarn, Bootstrap, Twitter Bootstrap, Material Design and Responsive Design(Bootstrap Responsive/Custom) & VueJS, React, Angular JS, Grunt JS, and Among Others also. Develop & implement user interfaces as per latest W3C Standards Rules. Create Cross-Browser and Cross-Platform Compatible & Standards-Compliant CSS-based page layouts. Involved in fixing Front-End Issues with the Layouts.",
        },
        {
            id: 4,
            name: "HDFC School",
            link: "https://www.thehdfcschool.com",
            team: "4",
            category: "School Inquery App",
            image: require("../assets/images/project/hdfcschool-img.png"),
            description:
                "HDFC School Website design and develop with html,css,Custom Bootstrap,Jquery,java Script",
        },
        {
            id: 5,
            name: "HDFCRED",
            link: "https://hdfcred.com",
            team: "18",
            category: "Property Real Estate Portal",
            image: require("../assets/images/project/hdfcred-img.png"),
            description:
                "HDFC RED is a 100 percent subsidiary of Housing Development Finance Corporation, an Indian financial conglomerate based in Mumbai, India. It operates under HDFC Developers Ltd. and is an online listings platform for real estate.",
        },
        {
            id: 6,
            name: "P&G Try",
            link: "https://pgtry.com/",
            team: "3",
            category: "P&G Product",
            image: require("../assets/images/project/pgtry.png"),
            description:
                "Group of products to commercialised p&g Portal",
        },
        {
            id: 7,
            name: "Pophop Web App",
            link: "https://www.pophop.com",
            team: "6",
            category: "Online Ticketing & Rewards App",
            image: require("../assets/images/project/pophop.png"),
            description:
                "Pophop Web app Showcase Website of Popularity for links to download app/ios file to your mobile through App Store / Google Play Store. Built Website using HTML, SASS, CSS3, J-Query Plugins, JavaScript, Bootstrap, Advance Custom Bootstrap, etc.",
        },
    ],
    all: [
        {
            id: 1,
            name: "Araya Construction",
            link: "https://www.araya.in",
            category: "Real Estate",
            team: "2",
            image: require("../assets/images/project/araya.png"),
            description:
                "This is a Static Showcase website. made with html/css/jquery",
        },
        {
            id: 2,
            name: "Poineer park",
            link: "https://www.poineerpark.com",
            category: "Real Estate",
            team: "2",
            image: require("../assets/images/project/poineer.png"),
            description:
                "Builder Static showcase website.",
        },
        {
            id: 3,
            name: "Presedia",
            link: "https://www.Presedia.com",
            category: "Real Estate",
            team: "2",
            image: require("../assets/images/project/presedia.png"),
            description:
                "Builder Static showcase website.",
        },
        {
            id: 4,
            name: "Mall For India",
            link: "https://www.mallforindia.com",
            team: "6",
            category: "India's Leading Online Shopping Store",
            image: require("../assets/images/project/mallforindia.png"),
            description:
                "E-Commerce Portal Designing & Development , Social media, Email Marketing, SEO/SMO, Banner Designing, Offers Campaign.",
        },
        {
            id: 5,
            name: "Web Experts Infotech",
            link: "https://www.weinfotech.llp",
            team: "5",
            category: "Company Official Portal",
            image: require("../assets/images/project/weinfo.png"),
            description:
                "Company Official Website designing & development, Digital Marketing and promotion.",
        },
        {
            id: 6,
            name: "We-infotech Career Page",
            link: "https://www.weinfotech.llp/carrer",
            team: "5",
            category: "Company Official Portal",
            image: require("../assets/images/project/weinfo-career.png"),
            description:
                "Company Official Inspiring Event & Career Page.",
        },
        {
            id: 7,
            name: "B7Directory",
            link: "https://www.b7directory.com",
            team: "2",
            category: "Local guide",
            image: require("../assets/images/project/b7.png"),
            description:
                "Project descriptionClassified Website for premium advertisement in rajasthan india, this is completed in wordpress and SEO enabled website make advertisement top in google ranking",
        },
        {
            id: 8,
            name: "Mark Fashion",
            link: "https://www.markfashion.com",
            team: "2",
            category: "E-Commerce",
            image: require("../assets/images/project/markfashion.png"),
            description:
                "A Complete E-Commerce site in woocommerce, wordpress with required customization in premiume theme.",
        },
        {
            id: 9,
            name: "Kalpana Hotel Manali",
            link: "https://www.kalpanahotel.com",
            team: "1",
            category: "Hotel",
            image: require("../assets/images/project/kalpana.png"),
            description:
                "Project descriptionPremium wp theme customized website for hotel.",
        },
        {
            id: 10,
            name: "Earth Developers",
            link: "https://www.earthdevelopers.in",
            team: "1",
            category: "Informative Showcase",
            image: require("../assets/images/project/earthdev.png"),
            description:
                "Project descriptionEarth Developers is a Property Website. I did this Fully Responsive & Update Dynamically Fetching Data & Contents From Admin Panel. With Inventory Management Application for Selling, Buying, Billing & Storing Records.",
        },
        {
            id: 11,
            name: "Road2Himachal",
            link: "http://road2himachal.com/",
            team: "2",
            category: "Travel Portal",
            image: require("../assets/images/project/road2h.png"),
            description:
                "Project descriptionItinerary selection and custom tour making from front end user e-commerce website",
        },
        {
            id: 12,
            name: "Jaipur Art Factory Web App",
            link: "https://jaipurartfactory.com/",
            team: "8",
            category: "Online E-Commerce Web App",
            image: require("../assets/images/project/jaf.png"),
            description:
                "Project descriptionJaipur Art Factory Mobile Web App Complete E-Commerce Application that serves to India as well as Other Country Also. Designed & Developed with HTML, HTML5, Bootstrap, Twitter Bootstrap, Advance CSS3, Angular JS, JavaScript, J-Query Plugins & etc.",
        },
        {
            id: 13,
            name: "Ncr Directory",
            link: "https://www.ncrdirectory.in",
            team: "2",
            category: "New Delhi Local guide",
            image: require("../assets/images/project/ncrdir.png"),
            description:
                "Project descriptionPremium wp theme customized website for Directory.",
        },
        {
            id: 14,
            name: "Jaipur Art Factory Mobile Web",
            link: "https://www.m.ncrdirectory.in",
            team: "5",
            category: "Online E-Commerce Web App",
            image: require("../assets/images/project/jafmob.png"),
            description:
                "Project descriptionJaipur Art Factory Mobile Web App Complete E-Commerce Application that serves to India as well as Other Country Also. Designed & Developed with HTML, HTML5, Bootstrap, Twitter Bootstrap, Advance CSS3, Angular JS, Java Script, J-Query Plugins & etc.",
        },
        {
            id: 15,
            name: "IndieFolio Creative Market Place",
            link: "https://www.indieFolio.com",
            team: "12",
            category: "Design & Creativity",
            image: require("../assets/images/project/indiefolio-img.png"),
            description:
                "IndieFolio is an online market network for Indian creative professionals. It is a platform for Indian creatives to showcase and promote their work. It will also serve to help companies to access Indian creative work and recruit on a nationwide scale. IndieFolio promote and provide ample opportunities and exposure to the Indian creative community. We strive to eliminate the barriers between talent and opportunity.",
        },
        {
            id: 16,
            name: "Property Monk",
            link: "https://www.propertymonk.com",
            team: "5",
            category: "Property Real Estate Portal",
            image: require("../assets/images/project/property-monk.jpeg"),
            description:
                "Worked with my team and we developed this app where user can search property on our portal and get the best deals and book/schedule for visit site their favourite site.",
        },
        {
            id: 17,
            name: "Mortgage Group",
            link: "https://homesearchbymortgage.com",
            team: "4",
            category: "Home Saerch Portal",
            image: require("../assets/images/project/mortage.jpeg"),
            description:
                "US Based Property portal where client filter property.",
        },
        {
            id: 18,
            name: "Datacom",
            link: "http://datacom.herokuapp.com/",
            team: "2",
            category: "Intercom support App",
            image: require("../assets/images/project/datacom.png"),
            description:
                "Its a Part of Intercom.io App. By this Application, Application Owner can know about Application logs and other users activity details. Application Management.",
        },
        {
            id: 19,
            name: "Online Audition Platform",
            link: "http://railsmancer.r15.railsrumble.com",
            team: "5",
            category: "Online Audition App",
            image: require("../assets/images/project/auditions.png"),
            description:
                "Rank - Positive reviews & Publics Visits. Front-End Design Part Complete Application Within 48Hrs Continuously with HTML/HTML5, Bootstrap, CSS/CSS3, SASS, JavaScript, J-Query and Many More..",
        },
        {
            id: 20,
            name: "Grihachikitsa",
            link: "https://www.Grihachikitsa.in",
            team: "2",
            category: "Appointment Management WebApp",
            image: require("../assets/images/project/grihachikitsa.png"),
            description:
                "Grihachikitsa is an Online Appointment Management Web Application. by this Org can Manage daily/weekly/monthly based appointments.",
        },
        {
            id: 21,
            name: "BreezeRide",
            link: "https://www.BreezeRide.in",
            team: "5",
            category: "Ride Pool Web App",
            image: require("../assets/images/project/breezehike.png"),
            description:
                "BreezeHike is a virtual marketplace where people connect to make travel more accessible. We match passengers BreezeHikers travel plans. Unlike hitchhiking, we allow BreezeHikers and drivers to interact prior to their voyage to build trust. The platform provides a seamless way for BreezeHikers and drivers to transact while making it cost effective for both parties. Built Website using HTML, SASS, CSS3, J-Query Plugins, JavaScript, Bootstrap, Advance Custom Bootstrap, etc.",
        },
        {
            id: 22,
            name: "Pophop Web App",
            link: "https://www.pophop.com",
            team: "6",
            category: "Online Ticketing & Rewards App",
            image: require("../assets/images/project/pophop.png"),
            description:
                "Pophop Web app Showcase Website of Popularity for links to download app/ios file to your mobile through App Store / Google Play Store. Built Website using HTML, SASS, CSS3, J-Query Plugins, JavaScript, Bootstrap, Advance Custom Bootstrap, etc.",
        },
        {
            id: 23,
            name: "P&G Shiksha Showcase Web/Mobile App",
            link: "https://pgshiksha.com",
            team: "2",
            category: "Shocase",
            image: require("../assets/images/project/pgshiksha.jpeg"),
            description:
                "Worked with the team and Developed P&G Shiksha app with latest and trending transition and effects/animation.",
        },
        {
            id: 24,
            name: "Lanes By Lens",
            link: "https://www.LanesByLens.com",
            team: "1",
            category: "Instagram Compaign",
            image: require("../assets/images/project/lanebylens.png"),
            description:
                "@LanesByLens Instagram Campaign Through #LanesByLens that takes place from the 10th to the 14th of December, 2016, we will be celebrating the best of the Mumbai lanes through a Instagram",
        },
        {
            id: 25,
            name: "Poddar Spraha Diamond",
            link: "http://www.poddarhousing.com",
            team: "2",
            category: "Shocase Property Website",
            image: require("../assets/images/project/poddar.png"),
            description:
                "Inquiry-Based Showcase website. Using with Custom HTML, SASS, JavaScript, Slick Slider, Mobile Friendly Pages. visit at http://www.poddarhousing.com/spraha/poddar_spraha_diamond",
        },
        {
            id: 26,
            name: "HDFC School",
            link: "https://www.thehdfcschool.com",
            team: "4",
            category: "School Inquery App",
            image: require("../assets/images/project/hdfcschool-img.png"),
            description:
                "HDFC School Website design and develop with html,css,Custom Bootstrap,Jquery,java Script",
        },
        {
            id: 27,
            name: "HDFCRED",
            link: "https://hdfcred.com",
            team: "18",
            category: "Property Real Estate Portal",
            image: require("../assets/images/project/hdfcred-img.png"),
            description:
                "HDFC RED is a 100 percent subsidiary of Housing Development Finance Corporation, an Indian financial conglomerate based in Mumbai, India. It operates under HDFC Developers Ltd. and is an online listings platform for real estate.",
        },
        {
            id: 28,
            name: "CF Spinner",
            link: "https://www.coverfox.com",
            team: "2",
            category: "Spinner Game",
            image: require("../assets/images/project/spinner.jpeg"),
            description:
                "Internal Spinner Game.",
        },
        {
            id: 27,
            name: "Coverfox Insurance Broking Pvt. Ltd",
            link: "https://coverfox.com",
            team: "30",
            category: "Insurance Portal",
            image: require("../assets/images/project/cf.jpeg"),
            description:
                "Coverfox is the biggest InsurTech platform. Offers simple, quick and hassle-free online insurance broking services for car, bike, health, life and travel insurance. Web applications using HTML 5, PostCSS, STYLUS, CSS3, SASS, LESS, J-Query, J-Query Plugins, JavaScript, Git, Yarn, Bootstrap, Twitter Bootstrap, Material Design and Responsive Design(Bootstrap Responsive/Custom) & VueJS, React, Angular JS, Grunt JS, and Among Others also. Develop & implement user interfaces as per latest W3C Standards Rules. Create Cross-Browser and Cross-Platform Compatible & Standards-Compliant CSS-based page layouts. Involved in fixing Front-End Issues with the Layouts.",
        },
        {
            id: 28,
            name: "P&G Try",
            link: "https://pgtry.com/",
            team: "3",
            category: "P&G Product",
            image: require("../assets/images/project/pgtry.png"),
            description:
                "Group of products to commercialised p&g Portal",
        },
        {
            id: 29,
            name: "Venus",
            link: "https://pgtry.com/selena/",
            team: "2",
            category: "P&G Product",
            image: require("../assets/images/project/venus.png"),
            description:
                "Venus & Gillete",
        },
        {
            id: 30,
            name: "Gillete",
            link: "https://pgtry.com/gillete/",
            team: "2",
            category: "P&G Product",
            image: require("../assets/images/project/gillete.png"),
            description:
                "Gillette's Kar Lo Safalta Mutthi Mein is Gillette's pan India marketing activity targeting college going students, to educate them about grooming, confidence and soft skills required for succeeding in their job interviews and landing their dream job. It involved campus activations with grooming sessions by mentors, Gillette Guard razor trials and sampling along with student engagement. The entire activity was digitized to ensure all stakeholders get timely updates about campaign performance.",
        },
        {
            id: 7,
            name: "Maven Organisation portfolio",
            link: "https://www.mavenfms.com/",
            team: "1",
            category: "Showcase portfolio",
            image: require("../assets/images/project/maven.png"),
            description:
                "Maven is a full-fledged facility management company based in India. Our offerings include comprehensive facility management solutions to meet the growing demands for a better and healthier working environment.",
        },
        {
            id: 31,
            name: "Whisper",
            link: "https://pgtry.com/whisper",
            team: "2",
            category: "P&G Product",
            image: require("../assets/images/project/whisper.png"),
            description:
                "Whisper wanted to reach out to young girls to educate them about feminine hygiene and care. This Super Sheroes Academy helped young girls watch educational content related to feminine hygiene from renowned bollywood persona like Bhumi Pednekar. It also featured an interactive quiz with rewards like certificate and Free samples of Whisper pads.",
        },
        {
            id: 32,
            name: "Adrian",
            link: "https://www.iiasadrian.com/",
            team: "2",
            category: "P&G Product",
            image: require("../assets/images/project/adrian.png"),
            description:
                "IiAS is at the forefront in terms of driving the corporate governance agenda in the Indian capital markets. Adrian provides shareholder voting intelligence and proxy advisory for over 1,100 companies. Insights on resolutions, investor voting patterns and voting rationale.",
        },
        {
            id: 33,
            name: "IIAS",
            link: "https://smart.iias.in/account/login/",
            team: "6",
            category: "Smart App to Rate and Vote",
            image: require("../assets/images/project/IIAS.png"),
            description:
                "SMART by IiAS provides a platform for Institutional investors to access IiAS's voting recommendations and vote on key shareholder issues as mandated by SEBI. It also provides a way for reporting, voting data reconciliation and generating auto proxy instructions based for different custodians.",
        },
        {
            id: 34,
            name: "Beshak",
            link: "https://www.beshak.org/",
            team: "8",
            category: "Discussion Forum",
            image: require("../assets/images/project/beshak.png"),
            description:
                "Beshak is India's first unbiased insurance advisor platform with marketplace to connect insurance buyers to insurance advisors.",
        },
    ]
};